import React, { useState, useCallback } from 'react';
import { DatePicker, TimeInput, SpaceBetween } from '@cloudscape-design/components';

const DateTimeSelector = ({ onDateChange, onTimeChange, defaultTime = '', defaultDate = '' }) => {
	const [selectedDate, setSelectedDate] = useState(defaultDate);
	const [selectedTime, setSelectedTime] = useState(defaultTime);

	return (
		<SpaceBetween direction="vertical" size="m">
			<DatePicker
				onChange={({ detail }) => {
					setSelectedDate(detail.value);
					onDateChange(detail.value);
				}}
				value={selectedDate}
				placeholder="Select a date"
			/>
			<TimeInput
				onChange={({ detail }) => {
					setSelectedTime(detail.value);
					onTimeChange(detail.value);
				}}
				value={selectedTime}
				format="hh:mm"
				placeholder="Select a time"
			/>
		</SpaceBetween>
	);
};

export default DateTimeSelector;
